import {
  IGetCryptoPaymentOptionsParams,
  IGetCryptoPaymentOptionsResult,
  Token,
} from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { web3Api } from 'store/queries';

const USDT_IN_ARBITRUM_SYMBOL = 'USD₮0';

const METADATA_TOKEN_SYMBOL_MAP: Record<string, Token> = {
  [USDT_IN_ARBITRUM_SYMBOL]: Token.USDT,
};

const updateOptionsWithCorrectTokenSymbols = (
  result: IGetCryptoPaymentOptionsResult,
): IGetCryptoPaymentOptionsResult => {
  return {
    options: result.options.map(option => ({
      ...option,
      tokens: option.tokens.map(token => {
        const isIncorrectToken = !Object.values(Token).includes(
          token.token_symbol,
        );

        return {
          ...token,
          token_symbol: isIncorrectToken
            ? METADATA_TOKEN_SYMBOL_MAP[token.token_symbol]
            : token.token_symbol,
        };
      }),
    })),
  };
};

export const {
  endpoints: { fetchPaymentOptions },
  useFetchPaymentOptionsQuery,
  useLazyFetchPaymentOptionsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchPaymentOptions: build.query<
      IGetCryptoPaymentOptionsResult,
      IGetCryptoPaymentOptionsParams | void
    >({
      queryFn: createNotifyingQueryFn(async params => {
        const service = MultiService.getService();

        const { result: data } = await service
          .getAccountingGateway()
          .getCryptoPaymentOptions(params);

        return { data: updateOptionsWithCorrectTokenSymbols(data) };
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  selectData: selectPaymentOptions,
  selectLoading: selectPaymentOptionsLoading,
  selectState: selectPaymentOptionsState,
} = createQuerySelectors({ endpoint: fetchPaymentOptions });
